import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./file-upload.scss";

function FileUpload(props) {
	const fileUploadRef = useRef();
	const {
		label,
		excelFile = null,
		error = "",
		onExcelUpload = () => { },
	} = props;
	const { t } = useTranslation();

	const handleUpload = () => {
		fileUploadRef.current?.click();
	};

	const onFileUpload = () => {
		const file = fileUploadRef.current?.files;
		if (!file?.length) {
			return;
		}
		onExcelUpload(file[0]);
	};

	return (
		<div className="file-upload-wrapper">
			{label && <label>{label}</label>}
			<input
				ref={fileUploadRef}
				className="d-none"
				type="file"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				onChange={onFileUpload}
			/>
			<div className="file-upload-control">
				<button onClick={handleUpload} className="file-upload-btn">
					{t("browse")}
				</button>
				{excelFile ? (
					<span className="file-upload-name">{excelFile?.name}</span>
				) : (
					<span className="file-upload-placeholder">
						{t("file-upload.no-file", "No file selected")}
					</span>
				)}
			</div>
			{error && <p className="file-upload-error">{t(error)}</p>}
		</div>
	);
}

export default FileUpload;
